export default {
  // 초청 행사 리스트
  gsGroup_inviteList: [],
}